<template>
    <layout-basic>
        <div class="section">
            <b-loading :is-full-page="loader.isFullPage" :active.sync="loader.isLoading" :can-cancel="false"></b-loading>
            <div class="columns" v-if="!reorderDisabled">
                <div class="column auto">

                    <p class="cp-help-text">
                        The reorder function is used when an order item has a production issue or a shipping issue. A good description of the issue must be provided.
                        <br>
                        <br>
                        <b>Production related issue</b>
                        <br>
                        Products can dots or stripes in the print, a binding that is not good or similar issues. In these cases, a reorder can be created.
                        <br>
                        <br>
                        <b>Shipping related issue</b>
                        <br>
                        For tracked shipping options a reorder can be made when the shipment was damaged or has gone missing.
                        <br>
                        <br>
                        <b>Free of charge</b>
                        <br>
                        A reorder is free of charge. All reorders will be checked by Cloudprinter.com and the print partner. In cases where the reorder is not covered the order will be canceled.
                    </p>
                    <br>
                    <br>
                    <form method="post" v-on:submit="submitReorderForm" novalidate>
                        <p class="title is-5">Select the products</p>
                        <template>
                            <section >
                                <div v-for="orderProduct in orderProducts">
                                    <div class="field">
                                        <b-checkbox v-model="model.reorderProducts.selected[orderProduct.id]" :native-value="orderProduct.id">
                                            <b>{{orderProduct.name}}</b>
                                        </b-checkbox>
                                    </div>
                                    <div v-if="model.reorderProducts.selected[orderProduct.id]" style="padding-left: 30px;">
                                        <b-field
                                                label="Product Quantity"
                                        >
                                            <b-numberinput
                                                    size="is-small"
                                                    v-model="model.reorderProducts.quantity[orderProduct.id]"
                                                    v-bind:value="1"
                                                    min="1" :max="orderProduct.quantity"
                                                    style="width: 135px;"
                                            ></b-numberinput>
                                        </b-field>

                                        <b-field
                                                label="Reorder Cause"
                                                :type="{'is-danger': errors.has('reorder cause')}"
                                                :message="errors.first('reorder cause')"
                                        >
                                            <b-select placeholder="Select a cause" expanded
                                                      v-validate="'required'"
                                                      v-model="model.reorderProducts.cause[orderProduct.id]"
                                                      name="reorder cause"
                                            >
                                                <option
                                                        v-for="cause in reorderCauses"
                                                        :value="cause.reorder_cause_reference"
                                                        :key="cause.reorder_cause_reference">
                                                    {{ cause.note }}
                                                </option>
                                            </b-select>
                                        </b-field>

                                        <b-field
                                                label="Reorder Description"
                                                :type="{'is-danger': errors.has('reorder description')}"
                                                :message="errors.first('reorder description')"
                                        >
                                            <b-input
                                                    v-model="model.reorderProducts.description[orderProduct.id]"
                                                    v-validate="'required'"
                                                    name="reorder description"
                                            ></b-input>
                                        </b-field>
                                    </div>
                                    <hr>
                                </div>
                            </section>
                        </template>

                        <br>
                        <h3 class="title is-5">Order configuration</h3>
                        <template v-if="purchaseOrder">
                            <section>
                                <b-field label="Shipping Level">
                                    <b-select disabled placeholder="Select a cause" expanded
                                              v-model="model.order.shipping.level"
                                    >
                                        <option
                                                v-for="level in shippingLevels"
                                                :value="level.name"
                                                :key="level.name">
                                            {{ level.name }}
                                        </option>
                                    </b-select>
                                </b-field>

                                <b-field
                                        label="Shipping Street"
                                        :type="{'is-danger': errors.has('street')}"
                                        :message="errors.first('street')"
                                >
                                    <b-input
                                            v-model="model.order.shipping.street"
                                            name="street"
                                            v-validate="'required'"
                                    ></b-input>
                                </b-field>

                                <b-field label="Shipping Zip">
                                    <b-input v-model="model.order.shipping.zip"></b-input>
                                </b-field>

                                <b-field
                                        label="Shipping City"
                                        :type="{'is-danger': errors.has('city')}"
                                        :message="errors.first('city')"
                                >
                                    <b-input
                                            v-model="model.order.shipping.city"
                                            name="city"
                                            v-validate="'required'"
                                    ></b-input>
                                </b-field>

                                <b-field label="Shipping Country">
                                    <b-input disabled v-model="model.order.shipping.country"></b-input>
                                </b-field>

                                <b-field label="Shipping State" v-if="model.order.shipping.state">
                                    <b-input disabled v-model="model.order.shipping.state"></b-input>
                                </b-field>
                            </section>
                        </template>

                        <br>

                        <p v-if="validationErrors" style="color: red">{{validationErrors}}</p>

                        <template>
                            <section class="has-text-right">
                                <input type="submit" name="submit" class="button is-info" value="Reorder">
                            </section>
                        </template>
                    </form>
                </div>
            </div>
            <div v-else>
                {{reorderDisabledMessage}}
            </div>
        </div>
    </layout-basic>
</template>

<script>
  import LayoutBasic from '@/layouts/LayoutBasic'
  import axios from 'axios'

  export default {
    name: 'reorder',
    components: {
      LayoutBasic,
    },
    data () {
      return {
        reorderDisabled: true,
        reorderDisabledMessage: '',
        loader: {
          isFullPage: true,
          isLoading: true,
        },
        orderId: null,
        orderProducts: [],
        reorderCauses: [],
        shippingLevels: [],
        purchaseOrder: {
          Shipping_level: null
        },
        cpOrder: {},
        model: {
          reorderProducts: {
            selected: {},
            cause: {},
            description: {},
            quantity: {}
          },
          order: {
            cp_reference: null,
            id: null,
            shipping: {
              level: null,
              country: null,
              city: null,
              state: null,
              street: null,
              zip: null,
            }
          }
        },
        validationErrors: false
      }
    },

    methods: {
      getOrderProducts() {
        const funcName = "cloudprintercom__getorderproducts";
        const reqData ={
          "arguments": JSON.stringify({
            "orderId" : this.orderId
          })
        };

        ZOHO.CRM.FUNCTIONS.execute(funcName, reqData)
          .then((data) => {
            this.orderProducts = JSON.parse('[' + data.details.output + ']');
          })
          .finally(() => {
            this.loader.isLoading = false;
          })
      },

      getReorderCauses() {
        ZOHO.CRM.CONNECTOR.invokeAPI("cloudprintercom.cloudprinter.getreordercauses", {})
          .then((data) => {
            const response = JSON.parse(data.response);
            this.reorderCauses = response.reorder_causes;
          })
      },

      getShippingLevels() {
        ZOHO.CRM.CONNECTOR.invokeAPI("cloudprintercom.cloudprinter.shippinglevels", {})
          .then((data) => {
            const response = JSON.parse(data.response);
            this.shippingLevels = response.shipping_levels;
          })
      },

      getOrderPurchase() {
        ZOHO.CRM.API.getRecord({Entity:"Purchase_Orders",RecordID:this.orderId})
          .then((response) => {
            this.model.order.shipping.level = response.data[0]['cloudprintercom.Shipping_level'];
            this.model.order.shipping.country = response.data[0].Shipping_Country;
            this.model.order.shipping.city = response.data[0].Shipping_City;
            this.model.order.shipping.state = response.data[0].Shipping_State;
            this.model.order.shipping.street = response.data[0].Shipping_Street;
            this.model.order.shipping.zip = response.data[0].Shipping_Code;
          })
      },

      submitReorderForm() {
        event.preventDefault();
        this.validationErrors = false;

        this.$validator.validate().then((result) => {
        if (result) {
          event.preventDefault();
          let productSelected = [];
          this.loader.isLoading = true;
          for (let productId in this.model.reorderProducts.selected) {
            if (this.model.reorderProducts.selected[productId] == true) {
              productSelected.push({
                'id': productId,
                'quantity': this.model.reorderProducts.quantity[productId] || 1,
                'cause': this.model.reorderProducts.cause[productId],
                'description': this.model.reorderProducts.description[productId]
              });
            }
          }

        if (productSelected.length == 0) {
            this.validationErrors = 'At least one product must be selected.';
            this.loader.isLoading = false;
            return false;
        }


          const funcName = "cloudprintercom__reorder";
          const reqData = {
            "arguments": JSON.stringify({
              "orderData": this.model.order,
              "productData": productSelected,
            })
          };

          ZOHO.CRM.FUNCTIONS.execute(funcName, reqData)
            .then((response) => {
              let responseData = JSON.parse(response.details.output);

              this.$toast.open({
                message: responseData.message,
                type: responseData.success ? 'is-success' : 'is-danger',
                duration: 10000
              });
            })
            .finally(() => {
              this.loader.isLoading = false;
            })
        }
        });
      },
      getCPOrder() {
        axios.post('/order/get', {zoho_order_id: this.orderId})
          .then((response) => {
            const responseData = response.data;
            responseData.log = JSON.parse(responseData.log);

            if (responseData.status == 'reordered') {
              this.reorderDisabledMessage = "Reorder is not possible. This order has already been reordered.";
              return true;
            }

            if (responseData.status == 'error') {
              this.reorderDisabledMessage = "Reorder is not possible. Because the order is not posted to the Cloudprinter.";
              return true;
            }

            this.cpOrder = responseData;
            this.model.order.cp_reference = responseData.cp_order_reference;
            this.reorderDisabled = false;
          })
          .catch((error) => {
            this.model.order.cp_reference = null;
            this.reorderDisabledMessage = "Reorder is not possible. Because the order is not posted to the Cloudprinter.";
          })
      }

    },

    created () {
      ZOHO.embeddedApp.on('PageLoad', (data) => {
        this.orderId = data.EntityId[0];
        this.model.order.id = data.EntityId[0];
        this.getOrderPurchase();
        this.getOrderProducts();
        this.getReorderCauses();
        this.getShippingLevels();
        this.getCPOrder();
      })

      ZOHO.embeddedApp.init()
    },
  }
</script>
